import type { CgmHardSyncDisplayData } from "src/types/cgm.types";

/**
 * Normalize RN → Web hard sync success payloads.
 * Supports nested { message, data: { stats } } or flat legacy shapes.
 */
export function normalizeCgmHardSyncPayload(
  raw: unknown
): CgmHardSyncDisplayData {
  const root =
    raw && typeof raw === "object" ? (raw as Record<string, unknown>) : {};
  const message =
    typeof root.message === "string" && root.message.length > 0
      ? root.message
      : "Sync successful";

  const inner =
    root.data && typeof root.data === "object"
      ? (root.data as Record<string, unknown>)
      : root;

  const asTime = (v: unknown): string | null => {
    if (typeof v === "string" && v.length > 0) return v;
    if (typeof v === "number" && !Number.isNaN(v)) return new Date(v).toISOString();
    return null;
  };

  return {
    message,
    data: {
      totalRecordsSynced: Number(inner.totalRecordsSynced ?? inner.totalSynced ?? 0),
      totalReadingsFromDevice: Number(
        inner.totalReadingsFromDevice ??
          inner.totalReadings ??
          inner.readingsCount ??
          0
      ),
      timeStart: asTime(inner.timeStart),
      timeEnd: asTime(inner.timeEnd),
    },
  };
}
